import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { TaskDefaultProps } from 'src/containers/project-container/Task/TaskPropTypes';
import { TASK_ACTIONS } from '../actions/TaskActions';

const initialState = () => ({
    currentRecord: { ...TaskDefaultProps },

    search: {
        data: [],
        currentPage: 0,
        pages: 0,
        count: 0,
    },

    upsertReqStatus: null,
    searchReqStatus: null,
});

export default (state = initialState(), action) => {
    switch (action.type) {
        
        case TASK_ACTIONS.TASK_SEARCH: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case TASK_ACTIONS.TASK_SEARCH_SUCCESS: {
            return {
                ...state,
                search: action.data,
                searchReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case TASK_ACTIONS.TASK_SEARCH_ERROR: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        
        case TASK_ACTIONS.TASK_UPSERT: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case TASK_ACTIONS.TASK_UPSERT_SUCCESS: {
            return {
                ...state,
                currentRecord: action.data,
                upsertReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case TASK_ACTIONS.TASK_UPSERT_ERROR: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        
        case TASK_ACTIONS.TASK_RESET: {
            return {
                ...state,
                currentRecord: { ...TaskDefaultProps },
            };
        }

        default:
            return state;
    }
};
